export default "__VITE_ASSET__DG8$fGIY__"